var utils = require( './utils' );

var sidebar_menu = ( function( $ ) {

	var $sidebar = null;

	var _init = function() {
		$sidebar = $( '#sidebar-menu' );

		if ( utils.viewport_size().width < 768 ) {
			$sidebar.find( '.header' ).on( 'click', _open_menu );
		}
	};

	var _open_menu = function( event ) {
		$sidebar.toggleClass( 'expanded' );
		$sidebar.find( '.menu-container' ).slideToggle();

		event.preventDefault();
	};

	if( $( '#sidebar-menu' ).length > 0  ) {
		$( window ).load( _init );
	}

	return{}

} ) ( jQuery );

module.exports = sidebar_menu;